import 'react-loading-skeleton/dist/skeleton.css';
import { GlobalErrorPage } from 'common';
import { getLanguage, initI18n } from 'i18n';
import { Settings } from 'luxon';
import ReactDOM from 'react-dom/client';

import { App } from './App';

initI18n({ baseUrl: import.meta.env.BASE_URL, namespaces: ['booking', 'common'] })
  .then(() => {
    Settings.defaultLocale = getLanguage();

    ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
  })
  .catch(error => {
    console.error(error);
    ReactDOM.createRoot(document.getElementById('root')!).render(<GlobalErrorPage />);
  });
